export default "<router-outlet #appRouter=\"outlet\"></router-outlet>"